import { Inject, Injectable } from '@angular/core'
import { Subscription } from 'rxjs'
import {
  User,
  UserContext,
  UserContextNotifier,
  UserService,
} from 'identity-services'
import { PageService } from './page.service'
import {
  userContextNotifierToken,
  userContextToken,
} from '../providers/user-context.provider'

@Injectable({ providedIn: 'root' })
export class AppComponentService {
  private userSubscription = new Subscription()

  public constructor(
    private readonly pageService: PageService,
    @Inject(userContextToken) private readonly userContext: UserContext,
    private readonly userService: UserService,
    @Inject(userContextNotifierToken)
    private readonly userContextNotifier: UserContextNotifier,
  ) {}

  public async onInit(
    onUserFetched: (user: User) => Promise<void>,
  ): Promise<void> {
    this.pageService.setPageTitle(
      $localize`:Head tag page title|Sans web play head tag title:Play Game Sans`,
    )

    this.pageService.addMetaTags()
    this.pageService.setInitialTheme()
    this.pageService.setInitialLocale()

    this.userSubscription = this.userContext.user$.subscribe(async (user) => {
      await onUserFetched(user)
    })

    if (this.userContext.isUserFetchedAtLeastOnce) {
      await onUserFetched(this.userContext.user)
      return
    }

    const user = await this.userService.getUser()
    this.userContextNotifier.notify(user)
  }

  public onDestroy(): void {
    this.userSubscription.unsubscribe()
  }
}
